import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/transfer.svg',
})
export class TransferIconComponent {}
